// import this after install `@mdi/font` package
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { uk, en } from 'vuetify/locale'
import { VFileUpload } from 'vuetify/labs/VFileUpload'
import Signal from "~/components/icons/signal.vue";

export default defineNuxtPlugin((app) => {

    const vuetify = createVuetify({
        theme: {
            defaultTheme: parseInt(localStorage.getItem('blackTheme') || '0') ? 'dark' : 'light',

            themes: {
                light: {
                    colors: {
                        primary: '#00897B', // teal-darken-1
                        error: '#B71C1C', // red-darken-4
                        "app-bar": '#37474F',
                        "app-loader": "#546E7A",
                        shaded: "#757575",
                        background: '#F5F5F5',
                        "panels-with-cards": '#EEEEEE',
                        "chat-message-received": "#ffffff",
                        "chat-message-sent": "#e3f2fd",
                        "frequency-range-selector": "#e9f4f4",
                        // Маркер непрочитаних повідомлень у треді заявки — той самий «непрочитане»,
                        // що й червоний badge у ChatsButton, але окремою змінною: чіп, його пульсація
                        // і рамка картки мають мінятись разом.
                        "unread-note": "#dc4e50",
                    },
                },
                dark: {
                    colors: {
                        primary: '#26A69A', // teal-lighten-2
                        error: '#E57373', // red-lighten-2
                        "app-bar": '#212B30',
                        "app-loader": "#455A64",
                        shaded: "#BDBDBD",
                        "panels-with-cards": '#424242',
                        "chat-message-received": "#353d3e",
                        "chat-message-sent": "#2b5a64",
                        "frequency-range-selector": "#283332",
                        "unread-note": "#dc4e50",
                    }
                }
            }
        },
        locale: {
            locale: 'uk',
            fallback: 'en',
            messages: { uk, en },
        },
        components: {
            VFileUpload,
        },
        icons: {
            aliases: {
                signal: Signal,
            },
        },
    });
    app.vueApp.use(vuetify);
});